import React, { Component } from "react";
import { withStyles } from "material-ui/styles";
import { Button } from "material-ui";

import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle
} from "material-ui/Dialog";
import Icon from "material-ui/Icon";
import { fade } from "material-ui/styles/colorManipulator";
import { DropTarget } from "react-dnd";
import CInput from "uis/CInput";
import CTooltips from "uis/CTooltips";
import getDndContext from "components/DndContext";
import ItemTypes from "./ItemTypes";
import AttrItem from "./AttrItem";

const styles = () => {
  return {
    dialogContent: {
      width: 700,
      position: "relative"
    },
    paperTitle: {
      color: "#575962",
      display: "inline-block",
      fontSize: "1.1rem",
      fontWeight: 600,
      marginLeft: 10
    },
    paperRow: {
      marginBottom: 15
    },
    paperDesc: {
      color: "#9699a2",
      fontSize: "1rem",
      fontWeight: 300,
      marginBottom: 5
    },
    paperValue: {
      color: "#575962",
      marginTop: "0.1rem",
      marginLeft: "2rem",
      display: "inline-block",
      fontSize: "1.1rem",
      fontWeight: 600
    },
    addButton: {
      border: "1px dashed gray",
      padding: "0.5rem 1rem",
      textAlign: "center",
      marginBottom: ".5rem",
      backgroundColor: "white",
      cursor: "pointer",
      outline: "none",
      "&:hover": {
        backgroundColor: fade("#26a69a", 0.1),
        // Reset on mouse devices
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  };
};
const itemTarget = {
  drop() {}
};
const dropTarget = connect => ({
  connectDropTarget: connect.dropTarget()
});

class EditAttrModal extends Component {
  moveAttrItem(id, atIndex) {
    const { attrItem, index } = this.findAttrItem(id);
    this.props.changeAttrItemOrder(attrItem, index, atIndex);
  }

  findAttrItem(id) {
    const { editAttrModal, localeNo } = this.props;
    const { attr } = editAttrModal;
    const { attrItems } = attr.locale[localeNo];
    const attrItem = attrItems.filter(c => c.id === id)[0];
    return {
      attrItem,
      index: attrItems.indexOf(attrItem)
    };
  }
  render() {
    const {
      connectDropTarget,
      classes,
      editAttrModal,
      localeNo,
      changeAttrName,
      discard,
      addNewAttrItem,
      removeAttrItem,
      changeAttrItem
    } = this.props;
    const { open, attr, attrId } = editAttrModal;
    if (!attr || !attr.locale || !attr.locale[localeNo]) {
      return null;
    }

    /**
     * Determines the department length based on locale.
     * @returns {number} The department length: 20 for Japanese locale,
     *                  40 for other locale.
     */
    const changeDepartmentLength = () => {
      return (localeNo === 'ja' || localeNo === 'zh') ? 20 : 40;
    };

    return (
      <Dialog open={open}>
        <DialogTitle id="form-dialog-title">属性編集</DialogTitle>
        <DialogContent className={classes.dialogContent}>
          {attr.presetFlg && (
            <Button
              raised
              dense
              style={{ position: "absolute", top: 10, right: 30 }}
              onClick={() => discard(attrId)}
            >
              初期設定に戻す
            </Button>
          )}
          <div>
            <div className={classes.paperDesc}>属性名*</div>
          </div>
          <div
            className={classes.paperPeriod}
            style={{ marginLeft: 0, width: "100%" }}
          >
            <CInput
              value={attr.locale && attr.locale[localeNo].attrName}
              fullWidth
              inputProps={{ maxLength: changeDepartmentLength() }}
              onChange={e => changeAttrName(e.target.value)}
            />
          </div>
          <div style={{ width: "100%", marginTop: 20 }}>
            <div
              className={classes.paperDesc}
              style={{ width: 490, display: "inline-block" }}
            >
              <CTooltips
                text="選択肢"
                title="※ ＋（追加）ボタンで選択肢を追加できます。"
                placement="right"
              />
            </div>
          </div>
          <div
            style={{
              padding: 10,
              border: "1px solid darkgrey",
              overflowY: "scroll",
              height: 320
            }}
          >
            {attr.locale &&
              connectDropTarget(
                <div>
                  {attr.locale[localeNo].attrItems.map((attrItem, i) => (
                    <AttrItem
                      key={attrItem.id}
                      id={attrItem.id}
                      value={attrItem.itemName}
                      index={i}
                      localeNo={localeNo}
                      changeAttrItem={(index, value) =>
                        changeAttrItem(index, value)
                      }
                      findAttrItem={id => this.findAttrItem(id)}
                      moveAttrItem={(id, index) => this.moveAttrItem(id, index)}
                      removeAttrItem={index => removeAttrItem(index)}
                      classes={classes}
                    />
                  ))}
                </div>
              )}
            {(!attr.locale || attr.locale[localeNo].attrItems.length < 30) && (
              <div
                role="button"
                id="addButton"
                tabIndex={0}
                onClick={addNewAttrItem}
                onKeyPress={null}
                className={classes.addButton}
              >
                <Icon style={{ verticalAlign: "sub", fontSize: 20 }}>add</Icon>
                <span>（追加）</span>
              </div>
            )}
          </div>
        </DialogContent>
        <DialogActions>
          <Button raised onClick={this.props.handleClose}>
            閉じる
          </Button>
          <Button raised onClick={() => this.props.handleRegist(attrId)}>
            {this.props.attrId ? "更新" : "登録"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default getDndContext()(
  DropTarget(ItemTypes.ATTR_ITEM, itemTarget, dropTarget)(
    withStyles(styles)(EditAttrModal)
  )
);



// WEBPACK FOOTER //
// ./src/components/SetupAttr/EditAttrModal.jsx